import React from 'react'
import { render } from 'react-dom'
import moment from 'moment'

import { modals, user as userService } from '@bikemap/js/services'
import {
    Storage,
    STORAGE_KEY_PROMOTION_MODAL_SHOWN_AT,
} from '@bikemap/js/utility'
import sessionData from '@bikemap/js/services/sessionData'
import promotions from './promotions'

/**
 * Whether there is a modal promotion currently ongoing.
 * @returns {Promise<boolean>}
 */
export async function hasCurrentPromotion() {
    return !!(await getCurrentPromotion())
}

/**
 * Run this on pages that should show promotion modals.
 */
export function initPromotionModal() {
    const lastShownAt = Storage.getItem(STORAGE_KEY_PROMOTION_MODAL_SHOWN_AT) || null
    // If saved to local storage that modal was shown in last two days
    const isRecentlyShown = !!(lastShownAt && moment(lastShownAt).diff(moment().subtract(1, 'days')) > 0)

    if (!isRecentlyShown) {
        showCurrentPromotionModal()
    }
}

/**
 * Show modal for the current promotion if there is one.
 */
async function showCurrentPromotionModal() {
    const promotion = await getCurrentPromotion()

    if (promotion) {
        const { Modal } = promotion

        modals.show('promotion-modal', {
            className: 'promotion-modal',
            init: modal => render((
                <Modal />
            ), modal.body),
        })

        // Save the last time this modal is shown (seconds)
        Storage.setItem(STORAGE_KEY_PROMOTION_MODAL_SHOWN_AT, moment().format())
    }
}

/**
 * Get the first promotion that is ongoing and targets the actuve user if there is one.
 * @returns {Promise<import('./promotions').PromotionConfig|null>}
 */
async function getCurrentPromotion() {
    const isLoggedIn = await sessionData.isLoggedIn()
    const isPremium = await userService.getIsPremium()

    for (const promotion of promotions) {
        const { isUserTarget, start, end } = promotion

        if (
            isUserTarget(isLoggedIn, isPremium) &&
            moment().isBetween(start, end, 'second', '[)')
        ) {
            return promotion
        }
    }

    return null
}
